import React from 'react';
import { Box, Typography } from '@mui/material';

interface SectionsHeaderProps {
    count: number;
    hint?: string;
    action: React.ReactNode;
}

export function SectionsHeader({ count, hint = 'arraste para alterar a ordem de exibição', action }: SectionsHeaderProps) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, gap: 2 }}>
            <Box>
                <Typography variant="h6" sx={{ color: 'primary.main', fontWeight: 600 }}>Seções</Typography>
                <Typography variant="caption" color="text.secondary">{count} seção(ões) · {hint}</Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>{action}</Box>
        </Box>
    );
}
